import * as React from 'react';
import { IOptionSelection } from '../../../../../../../../../services/quote/models';
import { Field } from 'redux-form';
import FieldFormControl from '../../../../../../../../../components/FieldFormControl';
import { isRequired } from '../../../../../../../../../util/validators';

interface IMTARegionSelectorProps {
  regionList: IOptionSelection[];
  selectedRegion: string;
  handleChange: any;
}

export const MTARegionSelector = ({ regionList, selectedRegion, handleChange }: IMTARegionSelectorProps) => {

  const handleChangeSelection = (value: string | number) => () => {
    handleChange(value)
  }

  return (
    <div className="region-selection-container">
      {regionList.map((region: IOptionSelection, index) => {

        let selectionClass = `trip-type-btn ${index} ${region.value}`

        if (selectedRegion === region.value) {
          selectionClass += ' selected'
        }

        return (
          <>
            <div
              className={selectedRegion === region.value ? 'region-title-selection selected' : 'region-title-selection'}
              key={index}>
              <Field
                name={`data.attributes.metadata.region`}
                id={index + '-btn'}
                type="radio"
                value={region.value}
                onChange={handleChangeSelection(region.value)}
                component={FieldFormControl}
                validate={[isRequired]}
              >
                <div className={selectionClass}>
                  <div>
                    {region?.label?.toUpperCase()}
                  </div>
                </div>
              </Field>
            </div>
          </>
        )
      })}
    </div>
  )
}
